// infirmierChatService.js - Service frontend pour le chat infirmier
import { auth } from '../firebase';

const FUNCTIONS_URL = 'https://europe-west1-medaviceia.cloudfunctions.net';

/**
 * Obtenir le token d'authentification
 */
async function getAuthToken() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Utilisateur non authentifié');
  }
  return await user.getIdToken();
}

/**
 * Envoyer un message dans le chat infirmier
 */
export async function sendInfirmierMessage(message, conversationId, conversationHistory = []) {
  try {
    const token = await getAuthToken();

    const response = await fetch(`${FUNCTIONS_URL}/professionalChat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        message,
        conversationId,
        conversationHistory,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de l\'envoi du message');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('❌ Erreur sendInfirmierMessage:', error);
    throw error;
  }
}

/**
 * Charger une conversation existante
 */
export async function loadInfirmierConversation(conversationId) {
  try {
    const token = await getAuthToken();

    const response = await fetch(`${FUNCTIONS_URL}/loadProfessionalConversation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        conversationId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors du chargement de la conversation');
    }

    const data = await response.json();
    return data.conversation;
  } catch (error) {
    console.error('❌ Erreur loadInfirmierConversation:', error);
    throw error;
  }
}

/**
 * Lister toutes les conversations
 */
export async function listInfirmierConversations() {
  try {
    const token = await getAuthToken();

    const response = await fetch(`${FUNCTIONS_URL}/listProfessionalConversations`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors du chargement des conversations');
    }

    const data = await response.json();
    return data.conversations;
  } catch (error) {
    console.error('❌ Erreur listInfirmierConversations:', error);
    throw error;
  }
}

/**
 * Supprimer une conversation
 */
export async function deleteInfirmierConversation(conversationId) {
  try {
    const token = await getAuthToken();

    const response = await fetch(`${FUNCTIONS_URL}/deleteProfessionalConversation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        conversationId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Erreur lors de la suppression');
    }

    return true;
  } catch (error) {
    console.error('❌ Erreur deleteInfirmierConversation:', error);
    throw error;
  }
}